import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { fetchInvoiceDetails, updateInvoiceStatus } from '../../../../../services/invoices';
import useInvoice from './useInvoice';
const UseInvoiceDetails = () => {
	const param = useParams();
	const id = param?.id;
	const navigate = useNavigate();
	const { handlePrintAndDownloadPdf } = useInvoice();
	const suburl = localStorage.getItem('suburl');
	const [invoiceDetails, setInvoiceDetails] = useState([]);
	const [updateStatus, setUpdateStatus] = useState(null);
	const [isUpdateStatusModelOpen, setUpdateStatusModelOpen] = useState(false);
	const [isVoidStatusModelOpen, setIsVoidStatusModelOpen] = useState(false);
	const [isShareLinkModelOpen, setShareLinkModelOpen] = useState(false);
	const [isRecordPaymentModalOpen, setIsRecordPaymentModalOpen] = useState(false);
	const [loader, setLoader] = useState({
		isLoading: false,
		status: null,
	});

	async function generateSalesInvoicesPdf(type = 'print', merge = false) {
		try {
			await handlePrintAndDownloadPdf(id, type, merge);
		} catch (error) {}
	}

	async function handleVoidStatus(status) {
		try {
			await updateInvoiceStatus(id, status);
			toast.success('Status Updated Successfully');
			navigate(`/user/${suburl}/invoices`);
		} catch (error) {
			toast.error(error?.message ?? 'Sometning went wrong!');
		}
	}

	async function handleUpdateStatus() {
		try {
			await updateInvoiceStatus(id, updateStatus);
			toast.success('Status Updated Successfully');
			navigate(`/user/${suburl}/invoices`);
		} catch (error) {
			toast.error(error?.message ?? 'Sometning went wrong!');
		}
	}
	async function getInvoiceDetails() {
		try {
			setLoader((prev) => ({
				...prev,
				isLoading: true,
				status: 'detail',
			}));
			const body = {
				ids: [id],
			};
			var { invoice } = await fetchInvoiceDetails(body);
			setInvoiceDetails(invoice);
		} catch (error) {
			toast.error('Something went wrong!');
		} finally {
			setLoader((prev) => ({
				...prev,
				isLoading: false,
				loaderId: 'detail',
			}));
		}
	}
	useEffect(() => {
		if (id) {
			getInvoiceDetails();
		}
	}, [id]);
	return {
		id,
		loader,
		suburl,
		navigate,
		invoiceDetails,
		generateSalesInvoicesPdf,
		setUpdateStatus,
		setUpdateStatusModelOpen,
		isUpdateStatusModelOpen,
		handleUpdateStatus,
		handleVoidStatus,
		setIsVoidStatusModelOpen,
		isVoidStatusModelOpen,
		isShareLinkModelOpen,
		setShareLinkModelOpen,
		isRecordPaymentModalOpen,
		setIsRecordPaymentModalOpen,
		getInvoiceDetails,
	};
};
export default UseInvoiceDetails;
